// Enabled addons, in boot order.
//
// Regenerated by `appfactory add`. Safe to edit by hand — it is a plain list.
//
// Each addon default-exports { id, boot(app)?, settingsRow()?, csp?, deepLinks? }.
// The chassis iterates this array; nothing else needs to change to add a feature.

import push from '../addons/push/index.js';

export default [push];
